<div id="inactivityModalContent">
    <p>Your session will expire in 30 seconds due to inactivity. Click below to continue your application.</p>
    <button  mat-flat-button
    id="inactivityContinueButton"
    type="submit"
    (click)="continueSession()">Continue</button>
</div>
